module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"de":{"Show filters":"Filter anzeigen","Hide filters":"Filter verbergen","Conversations could not be fetched.":"Konversationen konnten nicht abgerufen werden.","An error occurred":"Ein Fehler ist aufgetreten"}}')
  delete Component.options._Ctor
}
